import {
    QUIZ_QUESTION_FAILURE,
    QUIZ_QUESTION_REQUEST,
    QUIZ_QUESTION_SUCCESS,
} from './quizQuestionTypes'

const initialState = {
    loading: false,
    loadingMessage: '',
    fetchSuccess: false,
    questions: [],
    message: '',
    error: '',
}

const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case QUIZ_QUESTION_REQUEST:
            return {
                ...state,
                loading: true,
                loadingMessage: 'Fetching available quizzes...',
                fetchSuccess: false,
                questions: [],
                message: '',
                error: '',
            }
        case QUIZ_QUESTION_SUCCESS:
            return {
                ...state,
                loading: false,
                loadingMessage: 'Questions fetched...',
                fetchSuccess: true,
                questions: action.payload,
                message: '',
                error: '',
            }
        case QUIZ_QUESTION_FAILURE:
            return {
                ...state,
                loading: false,
                loadingMessage: 'Error fetching questions...',
                fetchSuccess: false,
                questions: [],
                message: '',
                error: action.payload,
            }
        default:
            return state
    }
}

export default reducer
